import { useSelector } from 'react-redux';
import { selectConfig, selectReferral } from '../../redux/selectors';
import { SuccessfulProcessSVG } from 'common-ui-components';
import ShareIcons from '../../components/ShareIcons';

const EndReferralProcess = () => {
  const {
    language: {
      referral: { endProcess: text },
    },
  } = useSelector(selectConfig);
  const { processId } = useSelector(selectReferral);
  const processText = text.processText.replace('{processId}', processId);
  const shareText = text.shareText.replace('{processId}', processId);
  const mailSubject = text.mailSubject;

  return (
    <section className='section endReferralProcess'>
      <div className='promoter-final-background'></div>
      <SuccessfulProcessSVG transparent style={{ width: '200px', margin: '0 0 20px' }} />
      <div className='endReferralProcess-details'>
        <p className='endReferralProcess-processText'>{processText}</p>
        <p className='endReferralProcess-subtitle'>{text.preAction}</p>
        <ShareIcons bodyText={shareText} subjectText={mailSubject} copyToastText={text.copyToastText} />
        <p className='endReferralProcess-subtitle-bottom'>{text.subtitle}</p>
      </div>
    </section>
  );
};

export default EndReferralProcess;
